export const DEV = /console\.(vf-(test|dev)[0-9]*)\.org$/;
